import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { Injectable } from '@angular/core';

import { Store } from '@ngxs/store';

import { ApiService } from '@app/core/api/api.service';
import { CustomerApiService } from '@app/core/api/customer-api.service';
import { ApiAccessLevel, CustomerApiRoute } from '@app/core/models/api.models';
import { StateService } from '@app/core/services/state.service';
import {
  PaymentMethod,
  PaymentMethodSetup,
} from '@app/core/store/states/customer/payment-methods/payment-methods-state.models';
import { assertArray } from '@app/core/utilities/array.utilities';

@Injectable({
  providedIn: 'root',
})
export class PaymentMethodsApiService extends CustomerApiService {
  readonly customerRoute = CustomerApiRoute.PaymentMethods;

  readonly accessLevel = ApiAccessLevel.CustomerAdmin;

  constructor(api: ApiService, ss: StateService, store: Store) {
    super(api, ss, store);
  }

  getPaymentMethods(): Observable<PaymentMethod[]> {
    return this.getList<PaymentMethod>({ disablePaging: true }).pipe(
      map((response) => response.data),
      catchError(() => of([])),
    );
  }

  getPaymentMethodSetup(): Observable<PaymentMethodSetup> {
    return this.post<PaymentMethodSetup>().pipe(map((response) => response.data));
  }

  setAsDefault(method: string): Observable<void> {
    return this.patch<PaymentMethod>({
      route: [...assertArray(this.apiRoute), method],
      data: {
        default: true,
      },
    }).pipe(
      catchError(() => of(void 0)),
      map(() => void 0),
    );
  }

  removeMethod(method: string): Observable<void> {
    return this.delete({
      route: [...assertArray(this.apiRoute), method],
    }).pipe(
      catchError(() => of(void 0)),
      map(() => void 0),
    );
  }
}
